import React, { useContext } from 'react'
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider'
import AtomicButton from '../../atomic/button/Button'
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';

const PageReloaded = () => {

    const { pageReloaded, setPageReloaded } = useContext(GlobalStateDataContext)
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 'calc(90vw - 0px)',
            height: '100vh'
        }}>

            <AccessTimeFilledIcon sx={{ fontSize: 100, color: 'orange' }} />
            <div style={{ fontSize: '18px', margin: '20px' }}> The screen is idle. Please tap to confirm you're active.</div>

            <AtomicButton
                label="Got It!"
                handleSubmit={() => { setPageReloaded(false) }}
                style={{
                    color: 'white',
                    backgroundColor: 'rgb(24, 20, 54)',
                    width: '450px',
                }}
                loading={false}
                disabled={false}
            />
        </div>

    )
}

export default PageReloaded